"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _reactResponsive = require("react-responsive");

var _theme = require("../../../Themes/theme");

var _About = _interopRequireDefault(require("./views/About"));

var _Gallery = _interopRequireDefault(require("./components/Gallery"));

var _Folder = _interopRequireDefault(require("./components/Folder"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _Menu = _interopRequireDefault(require("./components/Menu"));

var _Topnav = _interopRequireDefault(require("./components/Topnav"));

var _Elements = require("./Elements");

var _constants = require("../../constants/constants");

var _TermsOfUse = _interopRequireDefault(require("../../common/TermsOfUse"));

var _PrivacyPolicy = _interopRequireDefault(require("../../common/PrivacyPolicy"));

var _Contact = _interopRequireDefault(require("../../common/Contact"));

var _EmptyState = _interopRequireDefault(require("../../common/EmptyState"));

var _helpers = require("../../common/helpers");

var Newton = function Newton(_ref) {
  var _portfolio$user, _portfolio$folders, _portfolio$folders$fi, _portfolio$location, _portfolio$location2, _portfolio$user2, _portfolio$termsOfUse, _portfolio$privacyPol, _portfolio$user3, _portfolio$location3;

  var portfolio = _ref.portfolio,
      onSubmitMessage = _ref.onSubmitMessage,
      webpSupported = _ref.webpSupported;
  var isDesktopLarge = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1900px)'
  });
  var isDesktopMedium = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1440px)'
  });
  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });

  var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
      url = _useRouteMatch.url;

  var publicUrl = url === '/' ? '' : url;
  var baseUrl = "".concat(portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user = portfolio.user) === null || _portfolio$user === void 0 ? void 0 : _portfolio$user.username, ".").concat(process.env.REACT_APP_PORTFOLIO_HOST);
  var tosUrl = (0, _helpers.generateTosUrl)(portfolio, publicUrl);
  var policyUrl = (0, _helpers.generatePolicyUrl)(portfolio, publicUrl);
  var coverPhotoUrl = (0, _helpers.getCoverPhotoUrl)(portfolio === null || portfolio === void 0 ? void 0 : portfolio.coverPhoto); // Exclude null and empty folders

  var folders = (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$folders = portfolio.folders) === null || _portfolio$folders === void 0 ? void 0 : (_portfolio$folders$fi = _portfolio$folders.filter) === null || _portfolio$folders$fi === void 0 ? void 0 : _portfolio$folders$fi.call(_portfolio$folders, function (folder) {
    var _folder$photos, _folder$photos$edges;

    return folder && ((_folder$photos = folder.photos) === null || _folder$photos === void 0 ? void 0 : (_folder$photos$edges = _folder$photos.edges) === null || _folder$photos$edges === void 0 ? void 0 : _folder$photos$edges.length) > 0;
  })) || [];
  var userLocationData = [portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location = portfolio.location) === null || _portfolio$location === void 0 ? void 0 : _portfolio$location.city, portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location2 = portfolio.location) === null || _portfolio$location2 === void 0 ? void 0 : _portfolio$location2.country];
  var location = userLocationData.filter(function (val) {
    return val;
  }).join(', ');

  var renderFooter = /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    publicUrl: publicUrl,
    name: portfolio.title,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions,
    socialMedia: portfolio === null || portfolio === void 0 ? void 0 : portfolio.socialMedia,
    username: portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user2 = portfolio.user) === null || _portfolio$user2 === void 0 ? void 0 : _portfolio$user2.username,
    tosUrl: tosUrl,
    policyUrl: policyUrl,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    isCustomTos: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$termsOfUse = portfolio.termsOfUse) !== null && _portfolio$termsOfUse !== void 0 && _portfolio$termsOfUse.url),
    isCustomPolicy: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$privacyPol = portfolio.privacyPolicy) !== null && _portfolio$privacyPol !== void 0 && _portfolio$privacyPol.url)
  });

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (0, _theme.configPortfolioTheme)(portfolio.appearance.toLocaleLowerCase(), _constants.PORTFOLIO_THEME_FONTFAMILY[portfolio.font])
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_Elements.NewtonMain, null, /*#__PURE__*/_react["default"].createElement(_Elements.StyledOverlay, null), /*#__PURE__*/_react["default"].createElement(_Topnav["default"], {
    siteName: portfolio.title,
    publicUrl: publicUrl,
    folders: folders,
    colour: portfolio.colour
  }), isTabletPortrait && /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    publicUrl: publicUrl,
    folders: folders,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    appearance: portfolio === null || portfolio === void 0 ? void 0 : portfolio.appearance
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/about")
  }, /*#__PURE__*/_react["default"].createElement(_Elements.NewtonBody, {
    isTabletPortrait: isTabletPortrait,
    isDesktopSmall: isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_About["default"], {
    cover: coverPhotoUrl,
    description: portfolio.description,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions,
    socialMedia: portfolio === null || portfolio === void 0 ? void 0 : portfolio.socialMedia,
    username: portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user3 = portfolio.user) === null || _portfolio$user3 === void 0 ? void 0 : _portfolio$user3.username,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    location: location
  })), renderFooter), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/contact")
  }, /*#__PURE__*/_react["default"].createElement(_Elements.NewtonBody, {
    isTabletPortrait: isTabletPortrait,
    isDesktopSmall: isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_Contact["default"], {
    titleSize: "large",
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    showBelow: !isDesktopSmall,
    onSubmitMessage: onSubmitMessage,
    newtonStyles: true,
    isTabletPortrait: isTabletPortrait,
    isDesktopSmall: isDesktopSmall,
    isDesktopMedium: isDesktopMedium,
    isDesktopLarge: isDesktopLarge
  })), renderFooter), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/terms")
  }, /*#__PURE__*/_react["default"].createElement(_Elements.NewtonBody, {
    isTabletPortrait: isTabletPortrait,
    isDesktopSmall: isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_TermsOfUse["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title,
    activeSiteUrl: baseUrl,
    userCountry: (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location3 = portfolio.location) === null || _portfolio$location3 === void 0 ? void 0 : _portfolio$location3.country) || 'Canada'
  })), renderFooter), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/policy")
  }, /*#__PURE__*/_react["default"].createElement(_Elements.NewtonBody, {
    isTabletPortrait: isTabletPortrait,
    isDesktopSmall: isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_PrivacyPolicy["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title
  })), renderFooter), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/gallery/:legacyId")
  }, /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
    folders: folders,
    publicUrl: publicUrl,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    webpSupported: webpSupported
  }), /*#__PURE__*/_react["default"].createElement(_Elements.NewtonFooterMain, null, renderFooter)), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: publicUrl
  }, !!folders && folders.length > 0 ? /*#__PURE__*/_react["default"].createElement(_Folder["default"], {
    publicUrl: publicUrl,
    folders: folders,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    webpSupported: webpSupported
  }) : /*#__PURE__*/_react["default"].createElement(_Elements.StyledEmptyStateBox, {
    flex: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_EmptyState["default"], {
    site: portfolio.title
  })), /*#__PURE__*/_react["default"].createElement(_Elements.NewtonFooterMain, null, renderFooter))))));
};

Newton.defaultProps = {
  onSubmitMessage: function onSubmitMessage() {},
  webpSupported: false
};
Newton.propTypes = {
  portfolio: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    status: _propTypes["default"].oneOf(['ONBOARDING', 'ACTIVE', 'INACTIVE']),
    description: _propTypes["default"].string,
    appearance: _propTypes["default"].string,
    font: _propTypes["default"].string,
    folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    colour: _propTypes["default"].string.isRequired,
    coverPhoto: _propTypes["default"].shape({
      photo: _propTypes["default"].shape({
        images: _propTypes["default"].arrayOf(_propTypes["default"].shape())
      })
    }),
    socialMedia: _propTypes["default"].shape({
      instagram: _propTypes["default"].string,
      facebook: _propTypes["default"].string,
      twitter: _propTypes["default"].string
    }),
    location: _propTypes["default"].shape({
      country: _propTypes["default"].string,
      city: _propTypes["default"].string
    }),
    user: _propTypes["default"].shape({
      username: _propTypes["default"].string
    }),
    visibilityOptions: _propTypes["default"].shape({
      pxProfile: _propTypes["default"].string
    }),
    termsOfUse: _propTypes["default"].shape({
      url: _propTypes["default"].string
    }),
    privacyPolicy: _propTypes["default"].shape({
      url: _propTypes["default"].string
    })
  }).isRequired,
  onSubmitMessage: _propTypes["default"].func,
  webpSupported: _propTypes["default"].bool
};
var _default = Newton;
exports["default"] = _default;